import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import keyGenerator from 'utils/keys';

import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';
import {
  actions as orderActions,
  selectors as orderSelector,
  selectorsByType,
} from 'state/order';
import { selectors as warningsSelectors } from 'state/warnings';

import WeekDaysSelector from 'components/form/RecurringForm/components/WeekDaysSelector/component';

const enhance = compose(
  connect(
    (state) => {
      const typeOfOrder = orderSelector.getTypeOfOrder(state);
      return {
        days: selectorsByType.days[typeOfOrder]?.getDays(state),
        hasError:
          warningsSelectors.getWarnings(state)[keyGenerator.recurring.days()],
      };
    },
    {
      setDay: orderActions.setDay,
      sendEvent: analyticsActions.sendEvent,
    }
  ),
  lifecycle({
    componentDidUpdate({ days: prevDays }) {
      const { days, sendEvent } = this.props;
      if (prevDays.length !== days.length) {
        sendEvent(
          analyticsEvents.form.recurringWeekdayConfigurationChanged({ days })
        );
      }
    },
  })
);

export default enhance(WeekDaysSelector);
